import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import Button from "@mui/material/Button";
import { loginRequest } from "../authConfig";
import logoms from "../ms-logo.png";

export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);  // ← ใช้ redirect อย่างเดียว
  };

  return (
    <div>
      <Button
        className="LoginButton"
        onClick={handleLogin}
      >
        <img alt="ms Logo" src={logoms} className="mslogo" /> 
        Login with Microsoft
      </Button>
    </div>
  );
};
